import styled from "styled-components";

export const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 900;
  height: 10%;
  display: flex;
  align-items: center;
  background-color: rgb(52, 58, 64);
  background-color: var(--backgroundPrimary);
`;

const HeaderItem = styled.div`
  padding: 0.5rem;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const AppLogo = styled(HeaderItem)`
  flex: 0 0 15%;
`;

export const AppUser = styled(HeaderItem)`
  flex: 1 1 75%;
`;

export const AppActions = styled(HeaderItem)`
  flex: 0 0 10%;
  display: flex;
  justify-content: center;
  @media (min-width: 769px) {
    border-left: 1px solid #979797;
  }
`;
